import { cn } from "@/lib/utils";
import type { PublicCategory } from "@/types/models";
import {
  CATALOG_TOP_SECTION_ID,
  categorySectionId,
} from "../lib/groupProductsByCategory";

export interface CategoryFilterProps {
  categories: PublicCategory[];
  activeSectionId: string | null;
  onSelect: (sectionId: string | null) => void;
}

export default function CategoryFilter({
  categories,
  activeSectionId,
  onSelect,
}: CategoryFilterProps) {
  const linkClass = (active: boolean) =>
    cn(
      "w-full text-left py-2.5 pl-4 text-sm font-light tracking-wide border-l-2 transition-colors",
      active
        ? "border-primary-900 dark:border-white text-primary-900 dark:text-white"
        : "border-transparent text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-200 hover:border-primary-300 dark:hover:border-primary-600"
    );

  return (
    <nav aria-label="Navegação por categoria" className="flex flex-col">
      <p className="text-xs uppercase tracking-widest text-primary-500 dark:text-primary-500 mb-4 pl-4">
        Categorias
      </p>
      <button
        type="button"
        className={linkClass(activeSectionId === CATALOG_TOP_SECTION_ID)}
        aria-current={activeSectionId === CATALOG_TOP_SECTION_ID ? "true" : undefined}
        onClick={() => onSelect(null)}
      >
        Todos
      </button>
      {categories.map((category) => {
        const sectionId = categorySectionId(category.slug);
        const active = activeSectionId === sectionId;

        return (
          <button
            key={category.id}
            type="button"
            className={linkClass(active)}
            aria-current={active ? "true" : undefined}
            onClick={() => onSelect(sectionId)}
          >
            {category.name}
          </button>
        );
      })}
    </nav>
  );
}
